import { InjectionToken } from '@angular/core';
import type { BillingConfig } from './billing.interface';

export const BILLING_CONFIG = new InjectionToken<BillingConfig>(
  'BillingConfig',
);
